module.exports = __webpack_public_path__ + "h5/img/noxiaoxi.59d436b0.jpg";